module.exports = {
      id: "info-usage",
      viewBox: "0 0 20 21",
      url: __webpack_public_path__ + "img/icons.a7e6c507.svg#info-usage",
      toString: function () {
        return this.url;
      }
    }